import {useEffect, useMemo, useState} from "react"
import {useNavigate} from "react-router-dom"
import {Profile} from "@simplebooth/webkit"
import {useTranslation} from "react-i18next"
import ReactGA from "react-ga"
import throttle from "lodash.throttle"
import BlueButton from "../../../Button/BlueButton"
import stylesheet from "./ProfileTopBar.module.scss"

interface ProfileTopBarProps {
  profile: Profile
}

export default function ProfileTopBar({profile}: ProfileTopBarProps) {
  const [show, setShow] = useState(false)
  const navigate = useNavigate()
  const {t} = useTranslation()

  const handleScroll = () => {
    setShow(
      profile
      && window.scrollY > 800
      && (profile.public === undefined || profile.public),
    )
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttledHandleScroll = useMemo(() => throttle(handleScroll, 300), [profile])

  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll)
    return () => window.removeEventListener("scroll", throttledHandleScroll)
  })

  const handleProfileButtonClick = () => {
    ReactGA.event({category: "Profile Links", action: "Open Profile from Callout", label: profile.username})
    navigate(`/profiles/${profile.username.toLowerCase()}`)
  }

  return (
    <div className={`${stylesheet.callout} ${show ? stylesheet.show : ""}`}>
      <div className={stylesheet.profileSummary} onClick={handleProfileButtonClick}>
        <div className={stylesheet.profileImage}>
          <img src={profile.avatar?.url} alt={t("altText.profileAvatar")}/>
        </div>
        <div className={stylesheet.userAttributes}>
          <div className={stylesheet.primaryAttribute}>{profile.displayName ?? profile.company}</div>
          <div className={stylesheet.secondaryAttribute}>@{profile.username}</div>
        </div>
      </div>
      <div className={stylesheet.buttonContainer}>
        <BlueButton compact onClick={handleProfileButtonClick} style={{}}>
          {t("buttons.view")}
        </BlueButton>
      </div>
    </div>
  )
}
